export default "__VITE_ASSET__Qca2VAdm__"